<div class="relative flex w-[480px] flex-col items-center gap-4 rounded-lg bg-background-white p-6">
  <section>
    <h4 class="font-milliard font-medium">{{ 'perio_exam_reset_dialog_title' | translate }}</h4>
  </section>

  <section>
    <p class="text-center font-milliard text-h5 font-normal">{{ 'perio_exam_reset_dialog_content' | translate }}</p>
  </section>

  <section class="mt-4 flex w-full gap-4">
    <button class="btn-secondary flex-1 justify-center" (click)="onCancelClicked()">
      {{ 'perio_exam_reset_dialog_cancel_button' | translate }}
    </button>
    <button class="btn-warn flex-1 justify-center" (click)="onResetClicked()">
      {{ 'perio_exam_reset_dialog_reset_button' | translate }}
    </button>
  </section>
</div>
